import { Board } from '@/models/BoardModel';
import { client } from './API';
import { User } from '@/models/permission/AuthorityModel';
import { ENVIRONMENTAL_VARIABLES } from '@/utils/Environment';
import qs from 'qs';

/**
 * @returns list of boards
 */
export const fetchBoards = (params: { communityId: string; roomId: string }): Promise<Board[]> => {
  return client
    .get(`${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${params.communityId}/rooms/${params.roomId}/boards`, {
      params: { include: ['milestone_config', 'delivery_config'] },
      paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    .then((response) => response.data);
};

/**
 * @returns single board with id and metadata
 */
export const fetchBoard = ({
  communityId,
  roomId,
  boardId,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
}): Promise<Board> => {
  return client
    .get(`${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/boards/${boardId}`, {
      params: { include: ['folder_config', 'permissions', 'milestone_config', 'delivery_config'] },
      paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    .then((response) => response.data);
};

export const getRoomMembers = ({
  communityId,
  roomId,
  boardId,
  disciplines,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  disciplines: string[];
}): Promise<User[]> =>
  client
    .get(`${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/memberships`, {
      params: { board_id: boardId, limited_to: disciplines.toString() },
    })
    .then((response) => response.data);

export const getAllRoomMembers = ({
  communityId,
  roomId,
  boardId,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
}): Promise<User[]> =>
  client
    .get(`${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/memberships`)
    .then((response) => response.data);
